import { Entity } from '@backstage/catalog-model';

export const SCORECARD_EXEMPT_ANNOTATION = 'bidone/scorecard-exempt';

export const parseScorecardExemptions = (
  entity: Entity | undefined,
): Set<string> => {
  const raw = entity?.metadata.annotations?.[SCORECARD_EXEMPT_ANNOTATION];
  if (!raw) return new Set();
  return new Set(
    raw
      .split(',')
      .map(s => s.trim())
      .filter(Boolean),
  );
};
